import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateBizComponent } from './portals/instaciti/activate-biz/activate-biz.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./portal-binder-module/portal-binder.module').then(m => m.PortalBinderModule)
  },
  
  { path: '**', redirectTo: '' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
